/* eslint-disable jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions, jsx-a11y/anchor-is-valid */
import React from 'react';
import styled from 'react-emotion';
import PropTypes from 'prop-types';
import i18next from 'i18next';

import { ParagraphPanelContent } from '~/modules/accountManagement/components/basic/Labels';
import { LeftAlignedColumn } from '~/modules/coreUI/components/legacies/Columns';
import Image from '~/modules/coreUI/components/basic/Image';
import Button from '~/modules/coreUI/components/basic/Button';
import {
  MediumSpacer,
  XXXXXLargeSpacer,
  XLargeSpacer,
  XXLargeSpacer,
} from '~/modules/coreUI/components/legacies/Spacers';
import { Trans } from 'react-i18next';
import Panel from '~/modules/accountManagement/components/basic/Panel';
import { navigateToModal } from '~/modules/core/utils/modalHelpers';
import withUserInfo from '~/modules/core/utils/accessManagementHelpers/withUserInfo';
import RecoverPasswordForm from './RecoverPasswordForm';

const RecoverPasswordImage = styled(Image)`
  height: unset;
  width: unset;
  max-height: 120px;
`;

const IMAGE_PATH = `/${imagesPathName}/accountManagement/forgetPassword/recoverPassword`;

class RecoverPasswords extends React.Component {
  state = {
    panelError: null,
    isLoading: false,
  };

  onSuccess = (response) => {
    const { history, updateUserInfoTempPartial } = this.props;

    if (!this.form) {
      return;
    }

    updateUserInfoTempPartial({
      email: this.form.getValue().user_signin,
    });

    localStorage.setItem('verificationMedia', response.forgot_password_send_code.verification_via);

    navigateToModal(history, '/accountManagement/recoverpassword/VerifyByEmail');
  };

  onError = error => this.setState({ panelError: error });

  setLoadingState = (isLoading) => {
    this.setState({ isLoading });
  };

  render = () => {
    const { isLoading, panelError } = this.state;

    return (
      <Panel
        titleLabel={i18next.t('accountManagement:recoverPassword.panelTitle')}
        subTitleLabel={i18next.t('accountManagement:recoverPassword.panelSubtitle')}
        error={panelError}
      >
        <XXXXXLargeSpacer />
        <RecoverPasswordImage
          src={`${IMAGE_PATH}/image@2x.png`}
          srcSet={`${IMAGE_PATH}/image@2x.png 2x,
          ${IMAGE_PATH}/image@3x.png 3x`}
        />
        <XXXXXLargeSpacer />
        <ParagraphPanelContent>
          <LeftAlignedColumn>
            {i18next.t('accountManagement:recoverPassword.Enteryourusernameemailaddress')}
          </LeftAlignedColumn>
          <LeftAlignedColumn>
            {i18next.t('accountManagement:recoverPassword.secondParagraph')}
          </LeftAlignedColumn>
          <LeftAlignedColumn>
            {i18next.t('accountManagement:recoverPassword.thirdParagraph')}
          </LeftAlignedColumn>
        </ParagraphPanelContent>
        <MediumSpacer />
        <RecoverPasswordForm
          ref={(ref) => {
            this.form = ref;
          }}
          onFormError={error => this.onError(error)}
          onFormSuccess={response => this.onSuccess(response)}
          onFormLoading={loading => this.setLoadingState(loading)}
        />
        <XLargeSpacer />
        <Button block primary lg loading={isLoading} onClicked={() => this.form.submitForm()}>
          <Trans i18nKey="recoverPassword.Button" />
        </Button>
        <XXLargeSpacer />
      </Panel>
    );
  };
}

RecoverPasswords.propTypes = {
  history: PropTypes.shape({}).isRequired,
  updateUserInfoTempPartial: PropTypes.func.isRequired,
};

export default withUserInfo(RecoverPasswords);
